$(document).ready(function() {
    // Summernote
    $('#content').summernote({
        maxHeight: '500px',
        styleTags: ['p', 'h2', 'h3', 'h4', 'h5', 'h6'],
        fontNames: ['Barlow', 'Arial', 'Arial Black', 'Comic Sans MS', 'Courier New', 'Helvetica', 'Impact', 'Tahoma', 'Times New Roman', 'Verdana']
    });
    // console.log($('#content').summernote())

    // Changement des modèles selon la famille sélectionnée
    $('#selectFamily').on('change', function(){
        $.ajax({
            url: route('admin.family_sliders.getModels', { family_id: $(this).val() }),
            type: 'GET',
            dataType: 'json',
            success: function (models) {
                $('#currentModels').empty();
                for (var value in models) {
                    $('#currentModels').append('<option value="'+value+'">'+models[value]+'</option>');
                    }
            },
            error: function (e) {
                console.log(e);
            }
        });
    });

    // console.log('là');
    // if ($('#summernote').summernote('codeview.isActivated')) {
    //     console.log('ok');
    //     $('#summernote').summernote('codeview.deactivate');
    //   }

    $('.note-codable').on('blur', function() {
        if ($('#summernote').summernote('codeview.isActivated')) {
            $('[name="content"]').val($('.note-codable').val());
        }
    });
});